// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmTabs = function(options) {
		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			panelWrapper: '.tab-panels',
			selectBox: '.dropdown-menu--nav .dropdown__select',
			buttonSelector: '.tab-nav__button, .dropdown-menu--nav .dropdown__select',
			buttonSelectorOnly: '.tab-nav__button',
			tabActive: 'tab-nav__button--active',
			panelActive: 'tab-panels__item--active',
			tabPanelItem: '.tab-panels__item',
			tabPanelItemClass: 'tab-panels__item',
			tabNavItem: '.tab-nav__item',
			tabMobileClass: 'dropdown__link',
			tabTitle: '#tabTitle',
			tabLabel: '.feature-heading--tab-title',
			$window : $(window)
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {},
			scrollTest,
			mouseX,
			offset,
			xPosition,
			scrollWidth,
			$this;

		var $this = this;

		var $tabTitle = $(settings.tabTitle);

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		methods.initTabArrowButtons = function () {
			var tabList = $this.find('.tab-nav__list');

			if (  0 == $this.find('.tab-nav__arrows').length ) {
//				 tabList
//				 .css('overflow', 'auto');

				 var leftButton = `<button id="tabNavPrevButton" class="tab-nav__arrows tab-nav__arrows--left" aria-label="Nav Previous Button">
				 						<svg class="icon">
				 							<use xmlns:xlink="https://www.w3.org/1999/xlink" xlink:href="/themes/custom/nhra/assets/images/sprite.svg#arrow-left"></use>
										</svg>
									 </button>`;

				var rightButton = `<button id="tabNavNextButton" class="tab-nav__arrows tab-nav__arrows--right" aria-label="Nav Next Button">
									<svg class="icon">
										<use xmlns:xlink="https://www.w3.org/1999/xlink" xlink:href="/themes/custom/nhra/assets/images/sprite.svg#arrow-right"></use>
									</svg>
								</button>`;

				tabList
				.before(leftButton)
				.after(rightButton);
			} else {
				 tabList
				 .css('overflow', 'auto');
			}
		}

		methods.showHideArrows = function () {
			var tabList = $this.find('.tab-nav__list');
			var tabNavItem = $this.find('.tab-nav__item');

			var totalWidth = 0;

			tabNavItem.each(function() {
				totalWidth += parseInt($(this).width(), 10);
			});

			if (settings.$window.width() > 768 && totalWidth > $this.width()) {
				$this.addClass('tab-nav__arrows-active');
			} else {
				$this.removeClass('tab-nav__arrows-active');
			}
		}

		// Bind events
		methods.events = function($context) {
			$context.find(settings.buttonSelector).off('click.lmTabs change.lmTabs');

			methods.initTabArrowButtons();

			methods.showHideArrows();

			var didResize = false;

			settings.$window.resize(function() {
				didResize = true;
			});

			setInterval(function() {
				if ( didResize ) {
					didResize = false;
					methods.showHideArrows();
				}
			}, 250);

			$context.find(settings.buttonSelector).on('click.lmTabs change.lmTabs', function(evt) {
				evt.preventDefault();

				// Select + Change only Events
				if ($(this).is('select') && evt.type == 'change') {
					
					// Remove Active States
					var $panelWrapper = $context.next(settings.panelWrapper);
					$context.find('.' + settings.tabActive).removeClass(settings.tabActive);
					$panelWrapper.find('.' + settings.panelActive).removeClass(settings.panelActive);

					// Add Active Class to Tab
					var activeSelector = settings.buttonSelectorOnly + '[data-tab="' + $(this).val() +'"]';
					$(activeSelector).addClass(settings.tabActive);
					
					// Set Tab Title
					$tabTitle.html($('.' + settings.tabActive).html());

					// Add Active Class to Panel
					$('#' + $(this).val()).addClass(settings.panelActive);
				}

				// Button + Click only Events
				if ($(this).is('button') && evt.type == 'click') {
					
					// Cache wrapper selectors.
					var $panelWrapper = $context.next(settings.panelWrapper);

					if($panelWrapper.length < 1) {
						$panelWrapper = $(settings.panelWrapper);
					}

					// Remove any active classes.
					$context.find('.' + settings.tabActive).removeClass(settings.tabActive);
					$panelWrapper.find('.' + settings.panelActive).removeClass(settings.panelActive);

					// Add the new active state
					$(this).addClass(settings.tabActive);
				
					// Show correct panel
					$('#' + $(this).data('tab')).addClass(settings.panelActive);

					// Set Tab Title
					$tabTitle.html($('.' + settings.tabActive).html());

					//Set the Correct Select Option
					$(settings.selectBox).val($(this).data('tab'));
				}

			});

			// On mouseover, run the scrolltest function on an interval.
			$context.on('mouseover.lmTabs', function (event) {
				$this = $(this);

				// Set the scrollTest function to run on an interval.
				scrollTest = setInterval( function () {
					// Record the x position (mouse x minus the element x).
					offset = $this.offset();
					xPosition = mouseX - offset.left;

					// Reset the scrollWidth variable.
					scrollWidth = 0;

					// Loop through the tab items calculating the total scrollable width.
					$context.find('.tab-nav__item').each(function () {
						scrollWidth += $(this).width();
					});

					// If the mouse position on the element is 0 - 150, scroll left.
					if (xPosition < 150 && $context.find('.tab-nav__list').scrollLeft() > 0) {
						$context.find('.tab-nav__list').stop().animate({scrollLeft:$context.find('.tab-nav__list').scrollLeft() - 50}, '250', 'linear');

					// If the mouse position on the element is 150 away from the end or greater, scroll right.
					} else if (xPosition > $context.width() - 150 && $context.find('.tab-nav__list').scrollLeft() < scrollWidth) {
						$context.find('.tab-nav__list').stop().animate({scrollLeft:$context.find('.tab-nav__list').scrollLeft() + 50}, '250', 'linear');
					}
				}, 200);
			});

			// When the mouse moves, record it's x position.
			$(document).on( "mousemove.lmTabs", function (event) {
				mouseX = event.pageX;
			});

			// On mouseout, cancel the scrollTest function.
			$context.on('mouseout.lmTabs', function (event) {
				clearInterval(scrollTest);
				scrollTest = false;
			});
		}

		// On load function.
		methods.initContext = function ($context) {
			methods.setCurrentSettings($context);

			// If a hash exists in the address bar, investigate it
			if (window.location.hash) {

				// Cache the hash value as a selector
				var $possibleTab = $("#" + window.location.hash.substring(5));

				// Test to see if the selector exists on the page and has the tab panel class
				if ($possibleTab.length && $possibleTab.hasClass(settings.tabPanelItemClass)) {

					// Find the coresponding tabnav item based on index and trigger the click event.
					$(settings.tabNavItem).eq($possibleTab.index(settings.tabPanelItem)).find(settings.buttonSelectorOnly).trigger('click');
					$(settings.selectBox).val(window.location.hash.substring(5));
				}
			}

			// Move the Title (hide the old title)
			if($tabTitle.length) {
				$tabTitle.html($('.' + settings.tabActive).html());
				$(settings.tabLabel).not(settings.tabTitle).hide();
			}
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Run once methods when jquery plugin is called.
		methods.events(this);

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			var $this = $(this);

			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($this);
		});
	};
}(jQuery));
